export class ObjectUtil {
  public static getProperty(obj: any, key: string, defaultValue?: any) {
    return key.split('.').reduce((o, x) => {
      return typeof o === 'undefined' || o === null ? (o || defaultValue) : o[x];
    }, obj);
  }
}
